import SuperSelectTable from './superSelectTable';

export default SuperSelectTable;
